// Generated types for ActionValidationTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionValidationTaskReadAPI extends LLMTaskReadAPI {
}

export interface ActionValidationTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionValidationTaskReadAPISchema: z.ZodType<ActionValidationTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const ActionValidationTaskWriteAPISchema: z.ZodType<ActionValidationTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
